import { render } from "./BriefcaseIcon.vue?vue&type=template&id=a71092b6"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BriefcaseIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a71092b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a71092b6', __exports__)) {
    api.reload('a71092b6', __exports__)
  }
  
  module.hot.accept("./BriefcaseIcon.vue?vue&type=template&id=a71092b6", () => {
    api.rerender('a71092b6', render)
  })

}


export default __exports__